"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _core = require("@uppy/core");
var _emaFilter = _interopRequireDefault(require("@uppy/utils/lib/emaFilter"));
var _getTextDirection = _interopRequireDefault(require("@uppy/utils/lib/getTextDirection"));
var _StatusBarStates = _interopRequireDefault(require("./StatusBarStates.js"));
var _StatusBarUI = _interopRequireDefault(require("./StatusBarUI.js"));
var _locale = _interopRequireDefault(require("./locale.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "3.3.3"
};
var speedFilterHalfLife = 2000;
var ETAFilterHalfLife = 2000;
function getUploadingState(error, isAllComplete, recoveredState, files) {
  if (error) {
    return _StatusBarStates.default.STATE_ERROR;
  }
  if (isAllComplete) {
    return _StatusBarStates.default.STATE_COMPLETE;
  }
  if (recoveredState) {
    return _StatusBarStates.default.STATE_WAITING;
  }
  var state = _StatusBarStates.default.STATE_WAITING;
  var fileIDs = Object.keys(files);
  for (var i = 0; i < fileIDs.length; i++) {
    var progress = files[fileIDs[i]].progress;
    // If ANY files are being uploaded right now, show the uploading state.
    if (progress.uploadStarted && !progress.uploadComplete) {
      return _StatusBarStates.default.STATE_UPLOADING;
    }
    // If files are being preprocessed AND postprocessed at this time, we show the
    // preprocess state. If any files are being uploaded we show uploading.
    if (progress.preprocess) {
      state = _StatusBarStates.default.STATE_PREPROCESSING;
    }
    // If NO files are being preprocessed or uploaded right now, but some files are
    // being postprocessed, show the postprocess state.
    if (progress.postprocess && state !== _StatusBarStates.default.STATE_PREPROCESSING) {
      state = _StatusBarStates.default.STATE_POSTPROCESSING;
    }
  }
  return state;
}

// set default options, must be kept in sync with @uppy/react/src/StatusBar.js
var defaultOptions = {
  target: 'body',
  hideUploadButton: false,
  hideRetryButton: false,
  hidePauseResumeButton: false,
  hideCancelButton: false,
  showProgressDetails: false,
  hideAfterFinish: true,
  doneButtonHandler: null
};

/**
 * StatusBar: renders a status bar with upload/pause/resume/cancel/retry buttons,
 * progress percentage and time remaining.
 */
var _lastUpdateTime = /*#__PURE__*/_classPrivateFieldLooseKey("lastUpdateTime");
var _previousUploadedBytes = /*#__PURE__*/_classPrivateFieldLooseKey("previousUploadedBytes");
var _previousSpeed = /*#__PURE__*/_classPrivateFieldLooseKey("previousSpeed");
var _previousETA = /*#__PURE__*/_classPrivateFieldLooseKey("previousETA");
var _computeSmoothETA = /*#__PURE__*/_classPrivateFieldLooseKey("computeSmoothETA");
var _onUploadStart = /*#__PURE__*/_classPrivateFieldLooseKey("onUploadStart");
var StatusBar = exports.default = /*#__PURE__*/function (_UIPlugin) {
  function StatusBar(uppy, opts) {
    var _this;
    _classCallCheck(this, StatusBar);
    _this = _callSuper(this, StatusBar, [uppy, _objectSpread(_objectSpread({}, defaultOptions), opts)]);
    Object.defineProperty(_this, _computeSmoothETA, {
      value: _computeSmoothETA2
    });
    Object.defineProperty(_this, _lastUpdateTime, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this, _previousUploadedBytes, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this, _previousSpeed, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_this, _previousETA, {
      writable: true,
      value: void 0
    });
    _this.startUpload = function () {
      return _this.uppy.upload().catch(function () {
        // Error logged in Core
      });
    };
    Object.defineProperty(_this, _onUploadStart, {
      writable: true,
      value: function value() {
        var _this$uppy$getState = _this.uppy.getState(),
          recoveredState = _this$uppy$getState.recoveredState;
        _classPrivateFieldLooseBase(_this, _previousSpeed)[_previousSpeed] = null;
        _classPrivateFieldLooseBase(_this, _previousETA)[_previousETA] = null;
        if (recoveredState) {
          _classPrivateFieldLooseBase(_this, _previousUploadedBytes)[_previousUploadedBytes] = Object.values(recoveredState.files).reduce(function (pv, _ref) {
            var progress = _ref.progress;
            return pv + progress.bytesUploaded;
          }, 0);

          // We don't set `#lastUpdateTime` at this point because the upload won't
          // actually resume until the user asks for it.

          _this.uppy.emit('restore-confirmed');
          return;
        }
        _classPrivateFieldLooseBase(_this, _lastUpdateTime)[_lastUpdateTime] = performance.now();
        _classPrivateFieldLooseBase(_this, _previousUploadedBytes)[_previousUploadedBytes] = 0;
      }
    });
    _this.id = _this.opts.id || 'StatusBar';
    _this.title = 'StatusBar';
    _this.type = 'progressindicator';
    _this.defaultLocale = _locale.default;
    _this.i18nInit();
    _this.render = _this.render.bind(_this);
    _this.install = _this.install.bind(_this);
    return _this;
  }
  _inherits(StatusBar, _UIPlugin);
  return _createClass(StatusBar, [{
    key: "render",
    value: function render(state) {
      var capabilities = state.capabilities,
        files = state.files,
        allowNewUpload = state.allowNewUpload,
        totalProgress = state.totalProgress,
        error = state.error,
        recoveredState = state.recoveredState;
      var _this$uppy$getObjectO = this.uppy.getObjectOfFilesPerState(),
        newFiles = _this$uppy$getObjectO.newFiles,
        startedFiles = _this$uppy$getObjectO.startedFiles,
        completeFiles = _this$uppy$getObjectO.completeFiles,
        isUploadStarted = _this$uppy$getObjectO.isUploadStarted,
        isAllComplete = _this$uppy$getObjectO.isAllComplete,
        isAllErrored = _this$uppy$getObjectO.isAllErrored,
        isAllPaused = _this$uppy$getObjectO.isAllPaused,
        isUploadInProgress = _this$uppy$getObjectO.isUploadInProgress,
        isSomeGhost = _this$uppy$getObjectO.isSomeGhost;

      // If some state was recovered, we want to show Upload button/counter
      // for all the files, because in this case it’s not an Upload button,
      // but “Confirm Restore Button”
      var newFilesOrRecovered = recoveredState ? Object.values(files) : newFiles;
      var resumableUploads = !!capabilities.resumableUploads;
      var supportsUploadProgress = capabilities.uploadProgress !== false;
      var totalSize = 0;
      var totalUploadedSize = 0;
      startedFiles.forEach(function (file) {
        totalSize += file.progress.bytesTotal || 0;
        totalUploadedSize += file.progress.bytesUploaded || 0;
      });
      var totalETA = _classPrivateFieldLooseBase(this, _computeSmoothETA)[_computeSmoothETA]({
        uploaded: totalUploadedSize,
        total: totalSize,
        remaining: totalSize - totalUploadedSize
      });
      return (0, _StatusBarUI.default)({
        error: error,
        uploadState: getUploadingState(error, isAllComplete, recoveredState, state.files || {}),
        allowNewUpload: allowNewUpload,
        totalProgress: totalProgress,
        totalSize: totalSize,
        totalUploadedSize: totalUploadedSize,
        isAllComplete: false,
        isAllPaused: isAllPaused,
        // @ts-expect-error TODO: remove this in 4.x branch
        isAllErrored: isAllErrored,
        isUploadStarted: isUploadStarted,
        isUploadInProgress: isUploadInProgress,
        isSomeGhost: isSomeGhost,
        recoveredState: recoveredState,
        complete: completeFiles.length,
        newFiles: newFilesOrRecovered.length,
        numUploads: startedFiles.length,
        totalETA: totalETA,
        files: files,
        i18n: this.i18n,
        uppy: this.uppy,
        startUpload: this.startUpload,
        doneButtonHandler: this.opts.doneButtonHandler,
        resumableUploads: resumableUploads,
        supportsUploadProgress: supportsUploadProgress,
        showProgressDetails: this.opts.showProgressDetails,
        hideUploadButton: this.opts.hideUploadButton,
        hideRetryButton: this.opts.hideRetryButton,
        hidePauseResumeButton: this.opts.hidePauseResumeButton,
        hideCancelButton: this.opts.hideCancelButton,
        hideAfterFinish: this.opts.hideAfterFinish,
        // ts-expect-error TODO: remove this in 4.x branch
        isTargetDOMEl: this.isTargetDOMEl
      });
    }
  }, {
    key: "onMount",
    value: function onMount() {
      // Set the text direction if the page has not defined one.
      var element = this.el;
      var direction = (0, _getTextDirection.default)(element);
      if (!direction) {
        element.dir = 'ltr';
      }
    }
  }, {
    key: "install",
    value: function install() {
      var target = this.opts.target;
      if (target) {
        this.mount(target, this);
      }
      this.uppy.on('upload', _classPrivateFieldLooseBase(this, _onUploadStart)[_onUploadStart]);

      // To cover the use case where the status bar is installed while the upload
      // has started, we set `lastUpdateTime` right away.
      _classPrivateFieldLooseBase(this, _lastUpdateTime)[_lastUpdateTime] = performance.now();
      _classPrivateFieldLooseBase(this, _previousUploadedBytes)[_previousUploadedBytes] = this.uppy.getFiles().reduce(function (pv, file) {
        return pv + file.progress.bytesUploaded;
      }, 0);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.unmount();
      this.uppy.off('upload', _classPrivateFieldLooseBase(this, _onUploadStart)[_onUploadStart]);
    }
  }]);
}(_core.UIPlugin);
function _computeSmoothETA2(totalBytes) {
  var _classPrivateFieldLoo, _classPrivateFieldLoo2;
  if (totalBytes.total === 0 || totalBytes.remaining === 0) {
    return 0;
  }

  // When state is restored, lastUpdateTime is still nullish at this point.
  (_classPrivateFieldLoo2 = (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _lastUpdateTime))[_lastUpdateTime]) != null ? _classPrivateFieldLoo2 : _classPrivateFieldLoo[_lastUpdateTime] = performance.now();
  var dt = performance.now() - _classPrivateFieldLooseBase(this, _lastUpdateTime)[_lastUpdateTime];
  if (dt === 0) {
    var _classPrivateFieldLoo3;
    return Math.round(((_classPrivateFieldLoo3 = _classPrivateFieldLooseBase(this, _previousETA)[_previousETA]) != null ? _classPrivateFieldLoo3 : 0) / 100) / 10;
  }
  var uploadedBytesSinceLastTick = totalBytes.uploaded - _classPrivateFieldLooseBase(this, _previousUploadedBytes)[_previousUploadedBytes];
  _classPrivateFieldLooseBase(this, _previousUploadedBytes)[_previousUploadedBytes] = totalBytes.uploaded;

  // uploadedBytesSinceLastTick can be negative in some cases (packet loss?)
  // in which case, we wait for next tick to update ETA.
  if (uploadedBytesSinceLastTick <= 0) {
    var _classPrivateFieldLoo4;
    return Math.round(((_classPrivateFieldLoo4 = _classPrivateFieldLooseBase(this, _previousETA)[_previousETA]) != null ? _classPrivateFieldLoo4 : 0) / 100) / 10;
  }
  var currentSpeed = uploadedBytesSinceLastTick / dt;
  var filteredSpeed = _classPrivateFieldLooseBase(this, _previousSpeed)[_previousSpeed] == null ? currentSpeed : (0, _emaFilter.default)(currentSpeed, _classPrivateFieldLooseBase(this, _previousSpeed)[_previousSpeed], speedFilterHalfLife, dt);
  _classPrivateFieldLooseBase(this, _previousSpeed)[_previousSpeed] = filteredSpeed;
  var instantETA = totalBytes.remaining / filteredSpeed;
  var updatedPreviousETA = Math.max(_classPrivateFieldLooseBase(this, _previousETA)[_previousETA] - dt, 0);
  var filteredETA = _classPrivateFieldLooseBase(this, _previousETA)[_previousETA] == null ? instantETA : (0, _emaFilter.default)(instantETA, updatedPreviousETA, ETAFilterHalfLife, dt);
  _classPrivateFieldLooseBase(this, _previousETA)[_previousETA] = filteredETA;
  _classPrivateFieldLooseBase(this, _lastUpdateTime)[_lastUpdateTime] = performance.now();
  return Math.round(filteredETA / 100) / 10;
}
StatusBar.VERSION = packageJson.version;